import { Config, ConfigEnvironment } from './ConfigType';

export const config: Config = {
  env: ConfigEnvironment.PRODUCTION,
  release: '2f7fe3dabc1452994d9ef8f115e6227e68c74b64',
  sentryDSN: undefined,
  websiteURL: 'http://teslaeesti.com/',
  apiURLFrontend: '/api_api/',
  plausible: {
    siteId: 'teslaeesti.com',
    url: 'https://plausible.freeyourmusic.com/'
  }
};
